import Image from "next/image";

import AppDownloadBtn from "@domains/landing/components/AppDownloadBtn/AppDownloadBtn";

import * as S from "./Carrot.style";

const Carrot = () => {
  return (
    <S.Container>
      <S.Section1>
        <S.TitleH5>{"외국인 친구, 해외에서만\n만날수 있다고?"}</S.TitleH5>

        <S.TitleH5>이제는</S.TitleH5>

        <S.TitleH2>
          <strong>Enkoplay</strong> 할 때!
        </S.TitleH2>
      </S.Section1>

      <S.Section2>
        <S.Content>
          {
            "런칭 3개월 참여자수 4K돌파, 재참여율 60%\n숫자가 증명하는 국내 최초외국인 모임플렛폼 1위"
          }
        </S.Content>

        <S.TitleH6>
          <strong>언어</strong>는 다르지만
        </S.TitleH6>
        <S.TitleH6>
          <strong>취향</strong>은 통하니까!
        </S.TitleH6>

        <S.Logo>
          <Image fill src="/logo/enkoplay-logo.svg" alt="main-logo" />
        </S.Logo>

        <AppDownloadBtn text={"지금 당장 APP 다운받고\n이번주 모임 확인하기"} />
      </S.Section2>
    </S.Container>
  );
};

export default Carrot;
